module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-arrange-83f28668abe0a264c6ed296eb76e2d91.svg";